import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';
import { Form, Input, message } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  {
    key: 'defaultText',
    translationKey: 'text',
    label: 'Text',
    placeholder: 'Invalid credentials',
    textarea: true,
    required: true,
  },
];

export const SystemMessageCreate: React.FC = () => {
  const { formProps, onFinish } = useForm({ resource: 'system-messages' });
  const { push } = useNavigation();

  const handleSubmit = async (values: any) => {
    try {
      await onFinish({
        ...values,
        translations: normalizeTranslations(values.translations, LANG_FIELDS),
      });
      message.success('System message created');
      push('/system-messages');
    } catch (err: any) {
      message.error(err?.message || 'Failed to create system message');
    }
  };

  return (
    <Create
      resource="system-messages"
      saveButtonProps={{ onClick: () => formProps.form?.submit() }}
    >
      <Form {...formProps} layout="vertical" onFinish={handleSubmit}>
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Key" name="key" rules={[{ required: true }]}>
          <Input placeholder="auth.invalid_credentials" />
        </Form.Item>
        <Form.Item label="Namespace" name="namespace" rules={[{ required: true }]}>
          <Input placeholder="auth" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={2} placeholder="When this message is shown" />
        </Form.Item>
      </Form>
    </Create>
  );
};
